import { useScaleIndicator } from './useScaleIndicator';
import './ScaleIndicator.scss';

export const ScaleIndicator = () => {
    const { text, width } = useScaleIndicator();

    return (
        <div className="scale-indicator ui-not-clickable">
            <div className="scale-text">{text}</div>
            <div className="scale-bar" id="scale-bar" style={{ '--scale-bar-width': width }}></div>
        </div>
    );
};
